import React, { Component } from 'react';
import MetaItem from '../../../../Domain/MetaItem';
import MetaService from '../../../../Services/MetaService';
import MetaOperation from './MetaOperation';
import ButtonRow from '../../../../Elements/ButtonRow';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../../Elements/ErrorMessage';

class MetaAdminPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.None,
      selected: -1,
      selectedMeta: null,
      convertedResult: [],
      searchItem: {},
    };
    this.showPanel = this.showPanel.bind(this);
    MetaItem.removeMetaFunction = this.removeMetaFunction.bind(this);
  }

  clickOnRemoveOfficeOverhead(meta) {
    ErrorMessage.SetApprove(
      <span>
        You will remove this meta: {meta.DisplayName} <br />
        Are you sure?
      </span>,
      () => this.clickOnRemoveFromMeta(meta.MetaId)
    );
  }

  clickOnRemoveFromMeta(MetaId) {
    MetaService.RemoveMeta({ MetaId: MetaId, TemplateId: this.props.ReportTemplateId })
      .then(() => this.refresh())
      .catch(() => ErrorMessage.SetErrorMessage('MAP39'));
  }

  removeMetaFunction(id, item) {
    this.clickOnRemoveOfficeOverhead(item);
  }

  clickOnCancel() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <MetaOperation
            key='metaOperation'
            clickOnCancel={() => this.clickOnCancel()}
            ReportTemplateId={this.props.ReportTemplateId}
          />
        )}
      </div>
    );
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['']}
          tooltips={['Add New Meta']}
          colors={[ButtonColorsEnum.Primary]}
          keys={[ShownPanelsEnum.EditItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['Developer']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
          className='InnerMenuButtonFigmaList'
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={MetaItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={() => MetaService.GetMetaList(this.props.ReportTemplateId)}
          convertDBItemsFunction={MetaService.ConvertDBMetaList}
          searchItem={this.state.searchItem}
          errorCode='MAP114'
        />
      </div>
    );
  }
}

export default MetaAdminPanel;
